export default __webpack_public_path__ + "383a67a364df3be3e5486714ffa3d766.svg";